import styled from 'styled-components';

export const Container = styled.div`
  .codigo_ativo {
    top: 0;
    right: 5px;
    font-size: 0.7rem;
  }
`;
